import {
  Typography,
  CssBaseline,
  Toolbar,
  IconButton,
  Avatar,
  Drawer,
  Divider,
  Popover,
} from '@mui/material';
import { Box } from '@mui/system';
import { createContext, useEffect, useRef, useState } from 'react';
import { Arrow } from '../../../assets/icons/arrow';
import { LeftIcon } from '../../../assets/icons/leftArrow';
import { Logo } from '../../../assets/icons/logo';
import { Plus } from '../../../assets/icons/plus';
import { RightArrow } from '../../../assets/icons/rightArrow';
import ListMenu from '../../listMenu/listMenu';
import Profile from '../../profile/profile';
import MenuIcon from '@mui/icons-material/Menu';
import { Search } from '../../../assets/icons/search';
import { useLocation, useNavigate } from 'react-router-dom';
import useChangeRoutPath from '../../../hooks/changeRoutPath';
import {
  deleteSubject,
  getInterpretation,
  getSubjects,
} from '../../../api/smart-life';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { clearUser } from '../../../redux/slice/user';
import {
  AppBar,
  ContainerList,
  ContainerLogo,
  ContainerSearch,
  DrawerHeader,
  ListItemsMenu,
  LogoHeader,
  Main,
  PathArrowContainer,
  PathContainer,
  PathLink,
  ProfileContainer,
  Subjects,
  TextContainer,
  TypographyPopover,
  drawerWidth,
} from './mainLayout.style';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { NAVIGATION } from '../../../constants/pathName';
import { SmartlifeLogo } from '../../../assets/icons/smartlife';
import CustomSearchInput from '../../customInput/searchInput';
import {
  getIndicatorThunk,
  getInterpretationThunk,
  getRecommendationThunk,
  getSignalThunk,
  getSubjectsThunk,
} from '../../../redux/slice/data';
import { getSubjectId } from '../../../pages/biomarkers/[id]/IndicatorsAndSignals';
import HeaderRight from './HeaderRight';
import { resetCurrent } from '../../../redux/slice/currentItem';
import Breadcrumbs from './Breadcrumbs';
import { Link } from 'react-router-dom';
import { checkIsEditor } from '../../../utils/userUtils'
import http from '../../../api/http';

const Loader = (props: any) => {
  let [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const subjectId = getSubjectId();

  const fetchAll = async () => {
    setLoading(true);
    // await dispatch(getSubjectsThunk({}));
    // await dispatch(getRecommendationThunk({}));
    // await dispatch(getIndicatorThunk({}));
    // await dispatch(getInterpretationThunk({}));

    await Promise.all([
      dispatch(getSubjectsThunk({})),
      dispatch(getRecommendationThunk({})),
      dispatch(getIndicatorThunk({})),
      dispatch(getInterpretationThunk({})),
    ])
    setLoading(false);
  };

  (global as any).fetchAll = fetchAll;

  useEffect(() => {
    fetchAll();
  }, [subjectId]);

  if (loading) {
    return <div>Loading ....</div>;
  }

  return <div style={{ width: '100%' }}>{props.children}</div>;
};

const MainLayout = ({ children }: { children: any }) => {
  const COUNT_HEADER_SYMBOLS = 20;

  const [searchSubjectValue, setSearchSubjectValue] = useState('');
  const [isEditor, setIsEditor] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const { navigateTo } = useChangeRoutPath();
  const { user, navigate: userNavigate } = useAppSelector((state) => state.user);

  useEffect(() => {
    checkIsEditor().then(isEdit => {
      // @ts-ignore
      global.isEditor = isEdit;
      setIsEditor(isEdit);
    });
  }, []);

  useEffect(() => {
    // Запрос конфига при каждом маунте MainLayout
    http.get('/api/core/config').catch(() => {});
  }, []);

  const handleDrawerOpen = () => {
    setMenuOpen(true);
  };

  const handleDrawerClose = () => {
    setMenuOpen(false);
  };

  const handleSelectPath = (action: string, path?: any) => {
    if (action === 'click' && path) navigateTo(path);
    if (action === 'back') navigate(-1);
    if (action === 'next') navigate(+1);
  };

  console.log('RENDER DEUBG: Main Layout.js', loading);

  if (loading) {
    return <div>Loading ...</div>;
  }

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '300',
        lineHeight: '20px',
        letterSpacing: '0.28px',
      }}
      data-header
    >
      <CssBaseline />
      <AppBar position="fixed" menuOpen={menuOpen}>
        <Toolbar
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
            color: '#000',
          }}
        >
          <Box sx={{ display: 'flex', width: '60%' }}>
            <IconButton
              data-menu
              color="inherit"
              aria-label="menuOpen drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(menuOpen && { display: 'none' }) }}
            >
              <MenuIcon />
            </IconButton>
            <PathContainer data-animch>
              <PathArrowContainer>
                <LeftIcon
                  onClick={() => handleSelectPath('back')}
                  height={25}
                  width={25}
                />
                <RightArrow
                  onClick={() => handleSelectPath('next')}
                  height={25}
                  width={25}
                />
              </PathArrowContainer>

              <Breadcrumbs />
            </PathContainer>
          </Box>
          <Box
            sx={{ display: 'flex', width: '50%', justifyContent: 'flex-end' }}
          >
            {/* user info and send button  */}
            <HeaderRight />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            height: '100%',
            overflow: 'hidden',
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#333333',
          },
        }}
        variant="persistent"
        anchor="left"
        open={menuOpen}
        className="drawer"
      >
        <DrawerHeader data-animch>
          <ContainerLogo>
            <LogoHeader>
              <Link to={'/create-theme'}>
                <SmartlifeLogo />
              </Link>
              {/* <p>SMALT-LIFE</p> */}
            </LogoHeader>

            <div data-menu-toggle onClick={handleDrawerClose}>
              <Arrow
                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
              />
            </div>
          </ContainerLogo>
          {/* search subject   */}
          <ContainerSearch data-theme-search>
            <CustomSearchInput
              handleChange={(value) => setSearchSubjectValue(value)}
              value={searchSubjectValue}
            />
          </ContainerSearch>
        </DrawerHeader>
        <Divider data-theme-devider />
        <Subjects data-animch data-themes>
          <p data-themes-title>Themes</p>
          {isEditor && (
            <Plus
              onClick={() => navigateTo([NAVIGATION.CREATE_SUBJECT])}
              data-plus-theme
              data-hover
            />
          )}
        </Subjects>
        <ContainerList>
          <ListItemsMenu data-animch data-list-items>
            <ListMenu search={searchSubjectValue} />
          </ListItemsMenu>
        </ContainerList>
      </Drawer>
      <Loader>
        <Main menuOpen={menuOpen}>{children}</Main>
      </Loader>
    </Box>
  );
};

export default MainLayout;
